<template>
  <div class="menu">
    <div class="logo">
      <img
        v-if="title !== '首页'"
        src="@/assets/img/home/topLogo.png"
        width="426"
        height="45"
      />
      <img
        v-else
        src="@/assets/img/home/topLogo-white.png"
        width="426"
        height="45"
      />
    </div>
    <div class="menu-content">
      <ul>
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ active: title === item.title, white: title === '首页' }"
          @click="handleClick(index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyMenu",
  computed: {
    title() {
      const that = this;
      console.log("111", that.$store.state.menuItem);
      const menuItem = that.$store.state.menuItem;
      return menuItem.title;
    }
  },
  created() {
    const that = this;
    that.init();
  },
  data() {
    return {
      menuList: [
        { title: "首页", path: "/index" },
        { title: "公司介绍", path: "/about" },
        { title: "新闻资讯", path: "/news" },
        { title: "产品案例", path: "/case" },
        { title: "联系我们", path: "/contact" }
      ]
    };
  },
  methods: {
    init() {
      const that = this;
      const path = that.$route.path;
      console.log("test--->", path);
      if (path === "/") {
        that.$store.commit("updateMenuItem", that.menuList[0]);
      } else {
        const paths = path.split("/");
        if (paths[1] === "detail") {
          that.$store.commit("updateMenuItem", {
            title: "新闻资讯",
            path: "/news"
          });
        } else {
          for (let i = 0; i < that.menuList.length; i++) {
            if (that.menuList[i].path.indexOf(paths[1]) >= 0) {
              that.$store.commit("updateMenuItem", that.menuList[i]);
            }
          }
        }
      }
    },
    handleClick(index) {
      const that = this;
      const menuItem = that.$store.state.menuItem;
      const item = that.menuList[index];
      if (menuItem.path !== item.path) {
        that.$store.commit("updateMenuItem", item);
        that.$router.push(item.path);
      }
      that.$store.commit("updateProductsIndex", 0);
      that.$store.commit("updateSolutionsIndex", 0);
      that.$store.commit("updateCaseSuccsIndex", 0);
      that.$store.commit("updateCaseActive", 0);
    }
  }
};
</script>

<style>
@import "../assets/css/main.css";
.menu {
  width: 1280px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}
.menu-content ul {
  list-style: none;
}
.menu-content li {
  float: left;
  line-height: 40px;
  margin: 0 30px;
  font-family: Source Han Sans CN, serif;
  cursor: pointer;
  color: #272727;
  box-sizing: border-box;
  border-bottom: 2px solid rgba(0, 0, 0, 0);
}
.menu-content li.white {
  color: #ffffff;
}
.menu-content li:hover {
  border-bottom: 2px solid #0588cd;
}
.menu-content li.active {
  border-bottom: 2px solid #0588cd;
}
.menu-content .white:hover {
  border-bottom: 2px solid #ffffff;
}
.menu-content .white.active {
  border-bottom: 2px solid #ffffff;
}
</style>
